// src/components/Button/Button.jsx
import React from 'react';
import styles from './Button.module.css';

const VARIANTS = {
  primary: styles.btnPrimary,
  secondary: styles.btnSecondary, // Ensure this was defined in your CSS if you use it
  danger: styles.btnDanger,     // Ensure this was defined
  success: styles.btnSuccess,
  warning: styles.btnWarning,
  ghost: styles.btnGhost,
  outlinePrimary: styles.btnOutlinePrimary,
  outlineDanger: styles.btnOutlineDanger,
};

const SIZES = {
  xs: styles.btnXs,
  sm: styles.btnSm,
  md: styles.btnMd, // Default
  lg: styles.btnLg,
};

const Button = ({
  children,
  onClick,
  type = 'button',
  variant = 'primary',
  size = 'md',
  disabled = false,
  fullWidth = false,
  className = '',
  style, // Allow passing style prop
  ...props
}) => {
  const variantClass = VARIANTS[variant] || VARIANTS.primary;
  const sizeClass = SIZES[size] || ''; // Use empty string if 'md' has no specific class
  const fullWidthClass = fullWidth ? styles.btnFull : '';

  const combinedClassName = `
    ${styles.btn}
    ${variantClass}
    ${sizeClass}
    ${fullWidthClass}
    ${className}
  `.trim();

  return (
    <button
      type={type}
      className={combinedClassName}
      onClick={onClick}
      disabled={disabled}
      style={style} // Pass style prop
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;